import { FC, useCallback, useEffect, useState } from "react";
import { IComment, studentService } from "../../../../entities/student";
import { useGlobalMessageActions } from "../../../../entities/globalMessage";
import { FEATURES, hasFeature, useMyActions } from "../../../../entities/my";
import { MyError } from "../../../../shared/lib/error/MyError";
import { AuthError } from "../../../../shared/lib/error/AuthError";
import classes from './studentComments.module.scss'
import { OpenContainer } from "../../../../features/openContainer";
import { LoaderSpinner } from "../../../../shared/ui/spinner";
import { Items } from "../items/Items";
import { CreateComment } from "../../../../features/createComment";
import { useAppSelector } from "../../../../app/store/store";

interface IProps {
    studentId: number;
    targetUserId: number;
}

export const StudentComments: FC<IProps> = ({studentId, targetUserId}) => {

    const [comments, setComments] = useState<IComment[]>([])  
    const [count, setCount] = useState<number>(0)  
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [trigger, setTrigger] = useState<number>(0)
    const {setGlobalMessage} = useGlobalMessageActions()    
    const {setIsAuth} = useMyActions()
    const {my} = useAppSelector(s => s.myReducer)
    const canCreateComment = hasFeature(my, FEATURES.STUDENTS.CARD_COMMENTS_CREATE, targetUserId)

    const getComments = useCallback(async () => {
        try{
            setIsLoading(true)
            const commentsRes = await studentService.getComments(studentId)
            setComments(commentsRes.comments)
            setCount(commentsRes.comments_count)
        }
        catch(e){
            console.log(e)
            if(e instanceof AuthError){
                setIsAuth(false)
                setGlobalMessage({message: e.message, type: 'error'})
            }
            else if(e instanceof MyError){
                setGlobalMessage({message: e.message, type: 'error'})
            }
            else{
                setGlobalMessage({message: 'Ошибка при получении комментариев студента', type: 'error'})
            }
        }
        finally{
            setIsLoading(false)
        }
    }, [])

    useEffect(() => {
        getComments()
    }, [])

    const commentAdded = () => {
        getComments()
    }

    useEffect(() => {
        setTrigger(prev => prev + 1)
    }, [isLoading, comments])

    return (
        <section className={classes.container}>
            <OpenContainer
                title="Комментарии"
                trigger={trigger}
                icon={<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5H19V16H10L6 20V16H5V5Z" /><path d="M9 10H15M9 13H13" /></svg>}
            >
                <section className={classes.content}>
                    {canCreateComment && <CreateComment
                        studentId={studentId} 
                        onSuccess={commentAdded} 
                    />}
                    {
                        isLoading
                            ?
                        <section className={classes.loader}><LoaderSpinner /></section>
                            :
                        <>
                            <section className={classes.count}>Кол-во комментариев: {count}</section>
                            {
                                comments.length
                                    ?
                                <Items 
                                    studentId={studentId}
                                    comments={comments} 
                                />
                                    :
                                <></>
                            }
                        </>
                    }
                </section>
            </OpenContainer>
        </section>
    )
}
